import { DEFAULT_LOCALE, isLocale, type Locale, resources } from '@personal-blog/i18n';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export { LOCALES, isLocale } from '@personal-blog/i18n';
export type { Locale } from '@personal-blog/i18n';

const STORAGE_KEY = 'locale';

function resolveInitialLocale(): Locale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (isLocale(stored)) return stored;
  const nav = window.navigator.language.toLowerCase();
  return nav.startsWith('zh') ? 'zh' : DEFAULT_LOCALE;
}

await i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnNull: false,
});

if (typeof document !== 'undefined') document.documentElement.lang = i18n.language;

export async function setLocale(locale: Locale): Promise<void> {
  await i18n.changeLanguage(locale);
  if (typeof document !== 'undefined') document.documentElement.lang = locale;
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // ignore
  }
}

export { i18n };
